module.exports = __webpack_public_path__ + "media/images/common/ui/btn_chariloto-120cf78819888dee371ba3ebd43d25dd.png";